import { EnvironmentVariable } from './app-settings'

export class UrlsSettings {
  public readonly REACT_APP_LAB_URL: string

  constructor(envVariables: EnvironmentVariable) {
    this.REACT_APP_LAB_URL = envVariables.REACT_APP_LAB_URL as string
  }
}
